import { useState, useEffect } from "react";
import api from "../services/api";
import ApoieButton from "../components/ApoieButton/ApoieButton";
import HeroBanner from "../components/Home/HeroBanner/HeroBanner";
import Depoimentos from "../components/Home/Depoimentos/Depoimentos";
import Indicadores from "../components/Home/Indicadores/Indicadores";
import Parceiros from "../components/Home/Parceiros/Parceiros";
import Video from "../components/Home/Video/Video";
import lavrasHeroUrl from "../assets/images/lavras-hero.jpg";
import sabaraHeroUrl from "../assets/images/sabara-hero.jpg";
import macaiaHeroUrl from "../assets/images/macaia-hero.jpg";
import sabaraSlideUrl from "../assets/images/sabara-slide.png";
import lavrasPartnerSabaraUrl from "../assets/images/lavras-partner-sabara.png";
import lavrasPartnerProserUrl from "../assets/images/lavras-partner-proser.png";
import { getImageUrl } from "../utils/media";

const HOME_CACHE_KEY = "7geracoes:home-content";

const FALLBACK_HOME_DATA = {
  slideshow: [],
  highlightPhrase: {
    text: "Conheça o 7 Gerações!",
    link: "/quem-somos",
  },
  institutionalPhrase: "Transformando vidas e impactando gerações",
  testimonialsSection: { title: "Depoimentos" },
  testimonialCategories: [
    "atendidos",
    "familiares",
    "colaboradores",
    "parceiros",
  ],
  testimonials: [
    {
      name: "Vitor, 8 anos",
      subtitle: "Núcleo ProSer, em Sabará",
      text: "",
      category: "atendidos",
      photoUrl: sabaraSlideUrl,
    },
    {
      name: "Maria, familiar atendida",
      subtitle: "Núcleo ProSer, em Sabará",
      text: "",
      category: "familiares",
      photoUrl: macaiaHeroUrl,
    },
    {
      name: "Equipe 7 Gerações",
      subtitle: "Lavras, Minas Gerais",
      text: "",
      category: "colaboradores",
      photoUrl: lavrasHeroUrl,
    },
    {
      name: "Instituição parceira",
      subtitle: "Parceiro institucional",
      text: "",
      category: "parceiros",
      photoUrl: sabaraHeroUrl,
    },
  ],
  partnersSection: { title: "Parceiros" },
  partnerCategories: [
    "parceiros-institucionais",
    "parceiros-em-projetos",
    "patrocinio",
    "apoiadores",
  ],
  partners: [
    {
      name: "Prefeitura Municipal de Sabará",
      category: "parceiros-institucionais",
      logoUrl: lavrasPartnerSabaraUrl,
    },
    {
      name: "Instituto ProSer",
      category: "parceiros-em-projetos",
      logoUrl: lavrasPartnerProserUrl,
    },
    {
      name: "Prefeitura Municipal de Sabará",
      category: "patrocinio",
      logoUrl: lavrasPartnerSabaraUrl,
    },
    {
      name: "Instituto ProSer",
      category: "apoiadores",
      logoUrl: lavrasPartnerProserUrl,
    },
  ],
};

function getHomeSlides(homePage) {
  return Array.isArray(homePage?.slideshow)
    ? homePage.slideshow.filter((slide) =>
        getImageUrl(slide?.imageUrl || slide?.url || slide),
      )
    : [];
}

function getInitialHomeData() {
  try {
    const cachedHome = JSON.parse(localStorage.getItem(HOME_CACHE_KEY));

    if (cachedHome && typeof cachedHome === "object") {
      return {
        ...FALLBACK_HOME_DATA,
        ...cachedHome,
        slideshow: [],
      };
    }
  } catch {
    return FALLBACK_HOME_DATA;
  }

  return FALLBACK_HOME_DATA;
}

export default function Home() {
  const [homeData, setHomeData] = useState(getInitialHomeData);

  useEffect(() => {
    api
      .get("/config/home", {
        timeout: 8000,
        params: { _ts: Date.now() },
      })
      .then((res) => {
        const nextHomeData = {
          ...FALLBACK_HOME_DATA,
          ...res.data,
          slideshow: getHomeSlides(res.data),
        };

        setHomeData(nextHomeData);
        try {
          localStorage.setItem(HOME_CACHE_KEY, JSON.stringify(res.data));
        } catch {
          return;
        }
      })
      .catch(() => undefined);
  }, []);

  return (
    <>
      <HeroBanner
        slides={homeData?.slideshow}
        highlightPhrase={homeData?.highlightPhrase}
      />
      <ApoieButton />
      <Video video={homeData?.institutionalVideo} />
      <Depoimentos
        institutionalPhrase={homeData?.institutionalPhrase}
        section={homeData?.testimonialsSection}
        categories={homeData?.testimonialCategories}
        testimonials={homeData?.testimonials}
        isLoading={false}
        hasLoadError={false}
      />
      <Indicadores
        section={homeData?.indicatorsSection}
        indicators={homeData?.indicators}
      />
      <Parceiros
        section={homeData?.partnersSection}
        categories={homeData?.partnerCategories}
        partners={homeData?.partners}
        isLoading={false}
        hasLoadError={false}
      />
    </>
  );
}
